import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import { getApiClient, initializeApiClient } from "../apiService";


const AddAplicatoionInformation = async (body) => {

  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(`/api/AddApplication/AddApplication`, {
    body,
  });


  return response;
};

export const AgreeTerms = async (aI_ApplicationInformationId, status) => {

  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(`/api/ApplicantInformation/AgreeTerms`, {
    aI_ApplicationInformationId: aI_ApplicationInformationId,
    status: status
  });


  return response;
};


export default AddAplicatoionInformation;
